export default __webpack_public_path__ + "static/media/num2.54767132.png";